import { useEffect, useState } from 'react';
import { api } from '../api';

export default function Lojas() {
  const [lojas, setLojas] = useState([]);
  const [nova, setNova] = useState({ nome: '', cidade: '' });
  const [erro, setErro] = useState('');

  const carregar = () => api('/lojas').then(setLojas).catch(e => setErro(e.message));
  useEffect(() => { carregar(); }, []);

  const criar = async () => {
    if (!nova.nome.trim()) return;
    try {
      await api('/lojas', { method: 'POST', body: nova });
      setNova({ nome: '', cidade: '' });
      carregar();
    } catch (e) { setErro(e.message); }
  };

  const toggle = async l => {
    try {
      await api(`/lojas/${l.id}`, { method: 'PATCH', body: { ativo: !l.ativo } });
      carregar();
    } catch (e) { setErro(e.message); }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 14 }}>Lojas</h2>
      {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}
      <div className="card">
        <div className="row" style={{ marginBottom: 14 }}>
          <input className="input" style={{ flex: 2 }} placeholder="Nome da loja (ex.: Iguatu/CE)"
            value={nova.nome} onChange={e => setNova({ ...nova, nome: e.target.value })} />
          <input className="input" style={{ flex: 1 }} placeholder="Cidade"
            value={nova.cidade} onChange={e => setNova({ ...nova, cidade: e.target.value })} />
          <button className="btn" onClick={criar}>+ Cadastrar loja</button>
        </div>
        <table className="tbl">
          <thead><tr><th>Loja</th><th>Cidade</th><th>OS</th><th>Usuários</th><th>Situação</th><th></th></tr></thead>
          <tbody>
            {lojas.map(l => (
              <tr key={l.id}>
                <td style={{ fontWeight: 700 }}>{l.nome}</td>
                <td>{l.cidade || '—'}</td>
                <td>{l.total_os}</td>
                <td>{l.total_usuarios}</td>
                <td>
                  <span className="badge" style={{ background: l.ativo ? '#e2f3e8' : '#eef1f2', color: l.ativo ? 'var(--ok)' : 'var(--cinza)' }}>
                    {l.ativo ? 'Ativa' : 'Inativa'}
                  </span>
                </td>
                <td><button className="btn-sec" onClick={() => toggle(l)}>{l.ativo ? 'Desativar' : 'Ativar'}</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
